import { motion } from "framer-motion";
import SceneShell from "../components/SceneShell";
import CountUp from "../components/CountUp";

/**
 * Scene 04 — Build impact: 400 billion videos per day
 * Single hero number, dramatic.
 */
export default function Scene04_FourHundredBillion() {
  return (
    <SceneShell variant="forest" align="center" data-testid="scene-400-billion">
      {/* Glow that grows in */}
      <motion.div
        className="absolute inset-0 pointer-events-none"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.4 }}
        style={{
          background:
            "radial-gradient(ellipse at center, rgba(150,193,31,0.18) 0%, transparent 55%)",
        }}
      />

      <div className="relative max-w-[1500px] mx-auto w-full text-center">
        <motion.div
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="kn-eyebrow mx-auto"
        >
          Together · per day
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.85, filter: "blur(18px)" }}
          animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
          transition={{ duration: 1.2, delay: 0.4, ease: [0.16, 1, 0.3, 1] }}
          className="mt-10"
        >
          <div
            className="kn-display tnum leading-[0.9]"
            style={{
              color: "#96C11F",
              fontSize: "clamp(96px, 18vw, 280px)",
              textShadow: "0 0 80px rgba(150,193,31,0.35)",
            }}
            data-testid="400b-number"
          >
            <CountUp
              from={0}
              to={400}
              duration={2.4}
              startDelay={0.8}
              suffix="B"
            />
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 1.0 }}
          className="mt-8 kn-display text-4xl sm:text-6xl lg:text-7xl text-white"
          data-testid="400b-label"
        >
          videos. <span className="text-white/55">per day.</span>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 1.6 }}
          className="mt-14 inline-flex items-center gap-3 rounded-full px-5 py-3"
          style={{
            background: "rgba(255,255,255,0.06)",
            border: "1px solid rgba(255,255,255,0.12)",
            backdropFilter: "blur(8px)",
          }}
        >
          <span
            className="w-1.5 h-1.5 rounded-full"
            style={{ background: "#96C11F" }}
          />
          <span className="text-sm text-white/85 tracking-[0.18em]">
            Instagram · 200B
          </span>
          <span className="text-white/30">+</span>
          <span
            className="w-1.5 h-1.5 rounded-full"
            style={{ background: "#00deb6" }}
          />
          <span className="text-sm text-white/85 tracking-[0.18em]">
            YouTube Shorts · 200B
          </span>
        </motion.div>
      </div>
    </SceneShell>
  );
}
